import Vue from 'vue';
import VueBreadcrumbs from 'vue-breadcrumbs';

Vue.use(VueBreadcrumbs);
